import { Role, UserType } from '@nemuru-eng/js-api-client';

import { UserInStructure } from '@/types/UserInStructure';

export const getSelectedUserTypeAndRole = (selectedUser: UserInStructure): { type: UserType; role: Role } => {
  if ('channels' in selectedUser) return { type: UserType.MERCHANT, role: Role.ROLE_MERCHANT };
  if ('agents' in selectedUser) return { type: UserType.CHANNEL, role: Role.ROLE_CHANNEL };
  if ('name' in selectedUser) return { type: UserType.AGENT, role: Role.ROLE_AGENT };
  throw new Error('UserType not supported');
};
